module.exports = __webpack_public_path__ + "img/weddings_10_V.84a94fcb.webp";